import {updateComponentScopedValues} from './scopedValues'
import type {DeserializeComponentParams} from '../types'
import {DATA_TYPES} from '../../../../constants/constants'

export const updateComponentTransformationsStructure = (deserializationParams: DeserializeComponentParams) => {
    const {createExtArgs, compStructure, pageId, mappers} = deserializationParams
    updateComponentScopedValues(createExtArgs, compStructure, DATA_TYPES.transformations, pageId, mappers)
}
